

import __layout_0 from '/C:/WebServer/BayBookerV1/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/C:/WebServer/BayBookerV1/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithVerticalNav': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/Footer.vue'),
'components/HardRefresh': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/HardRefresh.vue'),
'components/NavBarI18n': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/NavBarNotifications.vue'),
'components/NavbarRefresh': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/NavbarRefresh.vue'),
'components/NavbarThemeSwitcher': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/ServerPerson': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/ServerPerson.vue'),
'components/UserProfile': () => import('/C:/WebServer/BayBookerV1/src/layouts/components/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
